<!-- 获取账号下所有授权停车场的编码接口内容 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {

            },
            responseCode: {
                "data": {
                    "parkInfoList": [
                        {
                            "parkCode": "2KM9FRZU",
                            "parkName": "111",
                            "parkNamePinyin": "111"
                        },
                        {
                            "parkCode": "2KM8BWT4",
                            "parkName": "170停车场",
                            "parkNamePinyin": "170TCC"
                        },
                        {
                            "parkCode": "2KM43Y461",
                            "parkName": "ake测试停车场",
                            "parkNamePinyin": "AKECSTCC"
                        },
                        {
                            "parkCode": "2KM43Y45",
                            "parkName": "CSV1.0测试停车场",
                            "parkNamePinyin": "CSV10CSTCC"
                        },
                        {
                            "parkCode": "PRJFZ094",
                            "parkName": "ddadaddadf",
                            "parkNamePinyin": "DDADADDADF"
                        },
                        {
                            "parkCode": "2KM9J7GC",
                            "parkName": "lltest停车场",
                            "parkNamePinyin": "LLTESTTCC"
                        },
                        {
                            "parkCode": "PRJXF0A8",
                            "parkName": "Mac开发停车场",
                            "parkNamePinyin": "MACKFTCC"
                        },
                        {
                            "parkCode": "PRJQV8MM",
                            "parkName": "wdl第三方车场测试",
                            "parkNamePinyin": "WDLDSFCCCS"
                        },
                        {
                            "parkCode": "2KM71M4R",
                            "parkName": "路边",
                            "parkNamePinyin": "AKLB"
                        },
                        {
                            "parkCode": "2KMA2HWG",
                            "parkName": "三车位路边停车点",
                            "parkNamePinyin": "AKSCWLBTCD"
                        },
                        {
                            "parkCode": "GDFSNHZT0001",
                            "parkName": "展厅停车场",
                            "parkNamePinyin": "AKZTTCC"
                        },
                        {
                            "parkCode": "GDFSNHCHARE012",
                            "parkName": "北京国家开发银行",
                            "parkNamePinyin": "BJGJKFYX"
                        },
                        {
                            "parkCode": "2KM8AU82",
                            "parkName": "测试测试00000",
                            "parkNamePinyin": "CSCS00000"
                        },
                        {
                            "parkCode": "2KNSBQ9E",
                            "parkName": "测试测试99",
                            "parkNamePinyin": "CSCS99"
                        },
                        {
                            "parkCode": "2KM42VJ8",
                            "parkName": "测试停车场",
                            "parkNamePinyin": "CSTCC"
                        },
                        {
                            "parkCode": "2KM9JMVZ",
                            "parkName": "测试停车场废弃了找不到运营商",
                            "parkNamePinyin": "CSTCCFQLZBDYYS"
                        },
                        {
                            "parkCode": "PR2WCYG4",
                            "parkName": "测试云停车场",
                            "parkNamePinyin": "CSYTCC"
                        },
                        {
                            "parkCode": "PR2WCYG5",
                            "parkName": "测试云停车场",
                            "parkNamePinyin": "CSYTCC"
                        },
                        {
                            "parkCode": "PR2WCYG6",
                            "parkName": "测试云停车场",
                            "parkNamePinyin": "CSYTCC"
                        },
                        {
                            "parkCode": "PR2WCYG0",
                            "parkName": "测试云停车场",
                            "parkNamePinyin": "CSYTCC"
                        },
                        {
                            "parkCode": "PR2WCYG1",
                            "parkName": "测试云停车场",
                            "parkNamePinyin": "CSYTCC"
                        },
                        {
                            "parkCode": "PR2WCYG2",
                            "parkName": "测试云停车场",
                            "parkNamePinyin": "CSYTCC"
                        },
                        {
                            "parkCode": "PR2WCYG3",
                            "parkName": "测试云停车场",
                            "parkNamePinyin": "CSYTCC"
                        },
                        {
                            "parkCode": "PR2VGT0L",
                            "parkName": "测试云停车场分组",
                            "parkNamePinyin": "CSYTCCFZ"
                        },
                        {
                            "parkCode": "2KKN885S",
                            "parkName": "昌俊停车场",
                            "parkNamePinyin": "CJTCC"
                        },
                        {
                            "parkCode": "2KM8B1XX",
                            "parkName": "的双方各第三个梵蒂冈",
                            "parkNamePinyin": "DSFGDSGFDG"
                        },
                        {
                            "parkCode": "GDFSNHFREE035",
                            "parkName": "桂豪酒店停车场",
                            "parkNamePinyin": "GHJDTCC"
                        },
                        {
                            "parkCode": "2KM43Y46",
                            "parkName": "瀚天科技城",
                            "parkNamePinyin": "HTKJC"
                        },
                        {
                            "parkName": "瀚天科技城地下停车场",
                            "parkNamePinyin": "HTKJCDXTCC"
                        },
                        {
                            "parkCode": "GDFSNHJSGJ01",
                            "parkName": "佳盛国际广场停车场",
                            "parkNamePinyin": "JSGJGCTCC"
                        },
                        {
                            "parkName": "简平路停车点",
                            "parkNamePinyin": "JPLTCD"
                        },
                        {
                            "parkCode": "2KKN6APN",
                            "parkName": "江南名居锦苑停车场",
                            "parkNamePinyin": "JNMJJYTCC"
                        },
                        {
                            "parkCode": "2KNRNIJC",
                            "parkName": "开发测试停车场",
                            "parkNamePinyin": "KFCSTCC"
                        },
                        {
                            "parkCode": "2KM9JF65",
                            "parkName": "开发停车场",
                            "parkNamePinyin": "KFTCC"
                        },
                        {
                            "parkCode": "2KNTYVWC",
                            "parkName": "开发停车场2",
                            "parkNamePinyin": "KFTCC2"
                        },
                        {
                            "parkCode": "PR318PN4",
                            "parkName": "开发云停车场（计费专用2）",
                            "parkNamePinyin": "KFYTCCJFZY2"
                        },
                        {
                            "parkCode": "PR31JFG2",
                            "parkName": "开发云停车场（计费专用3）",
                            "parkNamePinyin": "KFYTCCJFZY3"
                        },
                        {
                            "parkCode": "PR318PMT",
                            "parkName": "开发云停车场（计费专用）",
                            "parkNamePinyin": "KFYTCCJFZY"
                        },
                        {
                            "parkCode": "2KM6JE9J",
                            "parkName": "路边测试停车场2",
                            "parkNamePinyin": "LBCSTCC2"
                        },
                        {
                            "parkCode": "2KM6K94Q",
                            "parkName": "路边测试停车场2-3",
                            "parkNamePinyin": "LBCSTCC23"
                        },
                        {
                            "parkCode": "2KM7LZ5P",
                            "parkName": "路内性能测试停车场",
                            "parkNamePinyin": "LNXNCSTCC"
                        },
                        {
                            "parkCode": "2KKN6APO",
                            "parkName": "罗桂才测试停车场",
                            "parkNamePinyin": "LGCCSTCC"
                        },
                        {
                            "parkCode": "2KM58VWB",
                            "parkName": "模拟生产-南海万科",
                            "parkNamePinyin": "MNSCNHWK"
                        },
                        {
                            "parkName": "南海保利水城",
                            "parkNamePinyin": "NHBLSC"
                        },
                        {
                            "parkName": "南海万达广场",
                            "parkNamePinyin": "NHWDGC"
                        },
                        {
                            "parkCode": "GDFSGCZY0001",
                            "parkName": "南海中医院",
                            "parkNamePinyin": "NHZYY"
                        },
                        {
                            "parkName": "宁波奉化银泰城",
                            "parkNamePinyin": "NBFHYTC"
                        },
                        {
                            "parkCode": "2KM7OJR2",
                            "parkName": "平海路停车场",
                            "parkNamePinyin": "PHLTCC"
                        },
                        {
                            "parkCode": "2KKN6111",
                            "parkName": "万科.金色家园停车场",
                            "parkNamePinyin": "WKJSJYTCC"
                        },
                        {
                            "parkCode": "GDFSNHFREE004",
                            "parkName": "万科金色家园一期地下停车场",
                            "parkNamePinyin": "WKJSJYYQDXTCC"
                        },
                        {
                            "parkCode": "2KNU0TCE",
                            "parkName": "汪健测试停车场",
                            "parkNamePinyin": "WJCSTCC"
                        },
                        {
                            "parkCode": "2KPKIOSL",
                            "parkName": "性能测试停车场",
                            "parkNamePinyin": "XNCSTCC"
                        },
                        {
                            "parkCode": "2KKN6112",
                            "parkName": "云开发测试车场",
                            "parkNamePinyin": "ZBYKFCSCC"
                        },
                        {
                            "parkCode": "2KMAMN7L",
                            "parkName": "中间件测试停车点",
                            "parkNamePinyin": "ZJJCSTCD"
                        }
                    ]
                },
                "message": "业务成功", "resultCode": 0, "status": 1
                },
            infoData: {
                explain: "第三方接入系统请求智慧停车开放平台获取该账号下的所有授权停车场编码",
                t_url: this.commonUrls.test+"getAuthParkCodes",
                p_url: this.commonUrls.prod+"getAuthParkCodes",
                precondition: "无",
                fitSystem: "VEMS传统停车场, 云停车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkInfoList', info2: '是', info3: 'JSONArray', info4: '停车场列表，parkName：停车场名称,parkCode：停车场编码' }
                        ]
                },{
                    titleName: 'parkInfoList',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编码' },
                        { info1: 'parkName', info2: '是', info3: 'String', info4: '停车场名称' },
                        { info1: 'parkNamePinyin', info2: '是', info3: 'String', info4: '停车场名称拼音首字母' },

                    ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/park/getAuthParkCodes.vue